import {
  Box,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import AppBarCustom from "../component/AppBar";
import styled from "@emotion/styled";
import GaleriPage from "./komponen-page/Galeri";
import KomponenCard from "./komponen-page/KomponenCard";
import YoutubeCard from "./komponen-page/YoutubeCard";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function KomponenPage(params) {
  const theme = useTheme();
  const file = params.file;
  const Komponen = (props) => {
    return (
      <KomponenCard
        id={props.id}
        title={props.title}
        data={params.data.filter((item) => item.nama == props.title)[0]}
        image={
          params.file.filter((item) => item.id_foreign == "-" + props.id)[0]
        }
      />
    );
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: 0,
        bgcolor: "#E1E1E1",
      }}
    >
      <AppBarCustom selected="Komponen" />
      {/* <Toolbar sx={{ padding: 10 }} /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader theme={theme} />
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", marginBottom: 2 }}
          align="left"
        >
          Komponen
        </Typography>
        <Grid container direction={"column"} spacing={3}>
          <Grid>
            <GaleriPage id={101} data={params.file} />
          </Grid>
          <YoutubeCard
            id={102}
            title={"Youtube I"}
            data={params.data.filter((item) => item.nama == "Youtube I")[0]}
            image={params.file.filter((item) => item.id_foreign == "-102")[0]}
          />
          <YoutubeCard
            id={202}
            title={"Youtube II"}
            data={params.data.filter((item) => item.nama == "Youtube II")[0]}
            image={params.file.filter((item) => item.id_foreign == "-202")[0]}
          />
          <Grid>
            <Komponen id={103} title="Geografis" />
          </Grid>
          <Grid>
            <Komponen id={104} title="Topografi" />
          </Grid>
          <Grid>
            <Komponen id={105} title="Kependudukan" />
          </Grid>
          <Grid>
            <Komponen id={106} title="Perekonomian" />
          </Grid>
          <Grid>
            <Komponen id={107} title="Tenaga Kerja" />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
